import { Block } from 'factories/block';
import { setBlocksAction } from 'actions/setBlocksAction';
import { addHeaders } from 'factories/header';
import { State } from 'store/store';

export const updateThemeHeadersAction = async (dispatch, getState) => {
  // return async (getState, dispatch) => {
  const state = getState() as State;

  const hasStandardHeader = Object.values(state.blocks).find(block => {
    return block.type === 'StandardHeader';
  });

  if (hasStandardHeader) {
    // console.log('updated header exists');
    return state;
  }

  // console.log('header needs updating');

  // get saved theme from incoming module
  const { theme } = state;

  const {
    headerBackgroundColor,
    headerTextColor,
    backButton,
    progressBar,
    topicMenu,
  } = theme as any;

  const logo = Object.values(state.blocks).filter(
    (b: any) => b.type === 'Logo'
  )[0] as Block;

  const header = Object.values(state.blocks).find(block => {
    return block.type === 'Header';
  }) as Block;

  const [newBlock, newTree] = addHeaders(
    header,
    {
      headerBackgroundColor,
      headerTextColor,
      backButton,
      progressBar,
      topicMenu,
    },
    {
      src: logo?.props?.src,
      imageId: logo?.props?.imageId,
    }
  );

  // setNewBlockNewTree(newTree, newBlock, getStore(), setBlocksAction);

  newTree![newBlock.id] = newBlock;
  dispatch(setBlocksAction(newTree!));
};
// };
